import connector from '@/utils/Connection'

export default {
  actions: {
    async getAppBooks ({dispatch, commit}, {practiceId}) {
      const guestAccess = !connector.connected;
      const result = await connector.getAppBooksList(practiceId, guestAccess, 1);
      this.state.lastResponse = result;
      if (result.error == 0) {
        this.state.appbooksList = result.data;
      }
      return result;
    }
  }
}